import React               from 'react';
import AccountBalanceIcon       from '@material-ui/icons/AccountBalanceOutlined';
import PersonIcon               from '@material-ui/icons/Person';
import { IViewTab }             from '../ui/ViewTabs';
import employeeViewTypeModel, {
  IEmployeeViewType
}                               from './EmployeeViewTypeModel';
import mainPageModel            from '../main-navigation/MainPageModel';

const handleViewButtonClick = (view: IEmployeeViewType) => () => employeeViewTypeModel.view = view;

const employeeEditorViewTabs: IViewTab[] = [
  { title: 'Employee Details',                                                       disabled: () => employeeViewTypeModel.isView('details'),  onClick: handleViewButtonClick('details'),  content: <PersonIcon /> },
  { title: 'Time Off Balances', visible: () => mainPageModel.canViewTimeOffBalances, disabled: () => employeeViewTypeModel.isView('balances'), onClick: handleViewButtonClick('balances'), content: <AccountBalanceIcon /> },
];

export default employeeEditorViewTabs;
